import { EXTRA_CARDS } from "./data/extra-levels";

export type Level = "A1" | "A2" | "B1" | "B2" | "C1" | "C2";

export const LEVELS: Level[] = ["A1", "A2", "B1", "B2", "C1", "C2"];

export type Category =
  | "Pozdravi"
  | "Predstavljanje"
  | "Brojevi"
  | "Dani i mjeseci"
  | "Vrijeme"
  | "Pitanja"
  | "Zamjenice"
  | "Hrana i piće"
  | "Kupovina"
  | "Smjer i prijevoz"
  | "Stanovanje"
  | "Pridjevi"
  | "Glagoli"
  | "Fraze"
  | "Konjugacija"
  | "Rečenice"
  | "Posao"
  | "Zdravlje"
  | "Mediji"
  | "Priroda"
  | "Društvo";

export interface VocabCard {
  id: string;
  cat: Category;
  hr: string;
  de: string;
  hint?: string;
  level?: Level;
}

export interface ConjCard {
  id: string;
  cat: "Konjugacija";
  verb: string;
  pron: string;
  answer: string;
  isConj: true;
  level?: Level;
}

export interface SentenceCard {
  id: string;
  cat: "Rečenice";
  hr: string;
  de: string;
  tokens: string[];
  isSentence: true;
  level?: Level;
}

export type Card = VocabCard | ConjCard | SentenceCard;

export function getLevel(c: Card): Level {
  return c.level ?? "A1";
}

export const CATEGORIES: Category[] = [
  "Pozdravi",
  "Predstavljanje",
  "Brojevi",
  "Dani i mjeseci",
  "Vrijeme",
  "Pitanja",
  "Zamjenice",
  "Hrana i piće",
  "Kupovina",
  "Smjer i prijevoz",
  "Stanovanje",
  "Pridjevi",
  "Glagoli",
  "Fraze",
  "Konjugacija",
  "Rečenice",
  "Posao",
  "Zdravlje",
  "Mediji",
  "Priroda",
  "Društvo",
];

const A1_CARDS: Card[] = [

  { id: "v0", cat: "Pozdravi", hr: "dobro jutro", de: "guten Morgen" },
  { id: "v1", cat: "Pozdravi", hr: "dobar dan", de: "guten Tag" },
  { id: "v2", cat: "Pozdravi", hr: "dobra večer", de: "guten Abend" },
  { id: "v3", cat: "Pozdravi", hr: "laku noć", de: "gute Nacht" },
  { id: "v4", cat: "Pozdravi", hr: "bok", de: "hallo / tschüss (informell)" },
  { id: "v5", cat: "Pozdravi", hr: "zdravo", de: "hallo" },
  { id: "v6", cat: "Pozdravi", hr: "doviđenja", de: "auf Wiedersehen" },
  { id: "v7", cat: "Pozdravi", hr: "vidimo se", de: "wir sehen uns" },
  { id: "v8", cat: "Pozdravi", hr: "kako si?", de: "wie geht's? (informell)" },
  { id: "v9", cat: "Pozdravi", hr: "kako ste?", de: "wie geht es Ihnen? (formell)" },
  { id: "v10", cat: "Pozdravi", hr: "dobro, hvala", de: "gut, danke" },
  { id: "v11", cat: "Pozdravi", hr: "a ti?", de: "und du?" },
  { id: "v12", cat: "Pozdravi", hr: "hvala", de: "danke" },
  { id: "v13", cat: "Pozdravi", hr: "hvala lijepa", de: "vielen Dank" },
  { id: "v14", cat: "Pozdravi", hr: "molim", de: "bitte / gern geschehen" },
  { id: "v15", cat: "Pozdravi", hr: "da", de: "ja" },
  { id: "v16", cat: "Pozdravi", hr: "ne", de: "nein" },
  { id: "v17", cat: "Pozdravi", hr: "oprostite", de: "Entschuldigung (formell)" },
  { id: "v18", cat: "Pozdravi", hr: "oprosti", de: "Entschuldigung (informell)" },
  { id: "v19", cat: "Pozdravi", hr: "nema na čemu", de: "keine Ursache" },
  { id: "v20", cat: "Pozdravi", hr: "dobrodošli", de: "willkommen" },
  { id: "v21", cat: "Pozdravi", hr: "možda", de: "vielleicht" },
  { id: "v22", cat: "Pozdravi", hr: "naravno", de: "natürlich" },

  { id: "v23", cat: "Predstavljanje", hr: "zovem se", de: "ich heiße" },
  { id: "v24", cat: "Predstavljanje", hr: "kako se zoveš?", de: "wie heißt du?" },
  { id: "v25", cat: "Predstavljanje", hr: "ja sam iz", de: "ich komme aus" },
  { id: "v26", cat: "Predstavljanje", hr: "odakle si?", de: "woher kommst du?" },
  { id: "v27", cat: "Predstavljanje", hr: "drago mi je", de: "freut mich" },
  { id: "v28", cat: "Predstavljanje", hr: "i meni", de: "mich auch" },
  { id: "v29", cat: "Predstavljanje", hr: "koliko imaš godina?", de: "wie alt bist du?" },
  { id: "v30", cat: "Predstavljanje", hr: "imam dvadeset godina", de: "ich bin zwanzig Jahre alt" },
  { id: "v31", cat: "Predstavljanje", hr: "govorim malo hrvatski", de: "ich spreche ein bisschen Kroatisch" },
  { id: "v32", cat: "Predstavljanje", hr: "ne razumijem", de: "ich verstehe nicht" },
  { id: "v33", cat: "Predstavljanje", hr: "možeš li ponoviti?", de: "kannst du wiederholen?" },
  { id: "v34", cat: "Predstavljanje", hr: "kako se kaže ...?", de: "wie sagt man ...?" },
  { id: "v35", cat: "Predstavljanje", hr: "Hrvatska", de: "Kroatien" },
  { id: "v36", cat: "Predstavljanje", hr: "Njemačka", de: "Deutschland" },
  { id: "v37", cat: "Predstavljanje", hr: "hrvatski", de: "Kroatisch (Sprache)" },
  { id: "v38", cat: "Predstavljanje", hr: "njemački", de: "Deutsch (Sprache)" },

  { id: "v39", cat: "Brojevi", hr: "nula", de: "null" },
  { id: "v40", cat: "Brojevi", hr: "jedan", de: "eins" },
  { id: "v41", cat: "Brojevi", hr: "dva", de: "zwei" },
  { id: "v42", cat: "Brojevi", hr: "tri", de: "drei" },
  { id: "v43", cat: "Brojevi", hr: "četiri", de: "vier" },
  { id: "v44", cat: "Brojevi", hr: "pet", de: "fünf" },
  { id: "v45", cat: "Brojevi", hr: "šest", de: "sechs" },
  { id: "v46", cat: "Brojevi", hr: "sedam", de: "sieben" },
  { id: "v47", cat: "Brojevi", hr: "osam", de: "acht" },
  { id: "v48", cat: "Brojevi", hr: "devet", de: "neun" },
  { id: "v49", cat: "Brojevi", hr: "deset", de: "zehn" },
  { id: "v50", cat: "Brojevi", hr: "jedanaest", de: "elf" },
  { id: "v51", cat: "Brojevi", hr: "dvanaest", de: "zwölf" },
  { id: "v52", cat: "Brojevi", hr: "trinaest", de: "dreizehn" },
  { id: "v53", cat: "Brojevi", hr: "četrnaest", de: "vierzehn" },
  { id: "v54", cat: "Brojevi", hr: "petnaest", de: "fünfzehn" },
  { id: "v55", cat: "Brojevi", hr: "šesnaest", de: "sechzehn" },
  { id: "v56", cat: "Brojevi", hr: "sedamnaest", de: "siebzehn" },
  { id: "v57", cat: "Brojevi", hr: "osamnaest", de: "achtzehn" },
  { id: "v58", cat: "Brojevi", hr: "devetnaest", de: "neunzehn" },
  { id: "v59", cat: "Brojevi", hr: "dvadeset", de: "zwanzig" },
  { id: "v60", cat: "Brojevi", hr: "trideset", de: "dreißig" },
  { id: "v61", cat: "Brojevi", hr: "četrdeset", de: "vierzig" },
  { id: "v62", cat: "Brojevi", hr: "pedeset", de: "fünfzig" },
  { id: "v63", cat: "Brojevi", hr: "šezdeset", de: "sechzig" },
  { id: "v64", cat: "Brojevi", hr: "sedamdeset", de: "siebzig" },
  { id: "v65", cat: "Brojevi", hr: "osamdeset", de: "achtzig" },
  { id: "v66", cat: "Brojevi", hr: "devedeset", de: "neunzig" },
  { id: "v67", cat: "Brojevi", hr: "sto", de: "hundert" },
  { id: "v68", cat: "Brojevi", hr: "tisuću", de: "tausend" },
  { id: "v69", cat: "Brojevi", hr: "prvi", de: "erster" },
  { id: "v70", cat: "Brojevi", hr: "drugi", de: "zweiter" },
  { id: "v71", cat: "Brojevi", hr: "treći", de: "dritter" },

  { id: "v72", cat: "Dani i mjeseci", hr: "ponedjeljak", de: "Montag" },
  { id: "v73", cat: "Dani i mjeseci", hr: "utorak", de: "Dienstag" },
  { id: "v74", cat: "Dani i mjeseci", hr: "srijeda", de: "Mittwoch" },
  { id: "v75", cat: "Dani i mjeseci", hr: "četvrtak", de: "Donnerstag" },
  { id: "v76", cat: "Dani i mjeseci", hr: "petak", de: "Freitag" },
  { id: "v77", cat: "Dani i mjeseci", hr: "subota", de: "Samstag" },
  { id: "v78", cat: "Dani i mjeseci", hr: "nedjelja", de: "Sonntag" },
  { id: "v79", cat: "Dani i mjeseci", hr: "tjedan", de: "Woche" },
  { id: "v80", cat: "Dani i mjeseci", hr: "vikend", de: "Wochenende" },
  { id: "v81", cat: "Dani i mjeseci", hr: "siječanj", de: "Januar" },
  { id: "v82", cat: "Dani i mjeseci", hr: "veljača", de: "Februar" },
  { id: "v83", cat: "Dani i mjeseci", hr: "ožujak", de: "März" },
  { id: "v84", cat: "Dani i mjeseci", hr: "travanj", de: "April" },
  { id: "v85", cat: "Dani i mjeseci", hr: "svibanj", de: "Mai" },
  { id: "v86", cat: "Dani i mjeseci", hr: "lipanj", de: "Juni" },
  { id: "v87", cat: "Dani i mjeseci", hr: "srpanj", de: "Juli" },
  { id: "v88", cat: "Dani i mjeseci", hr: "kolovoz", de: "August" },
  { id: "v89", cat: "Dani i mjeseci", hr: "rujan", de: "September" },
  { id: "v90", cat: "Dani i mjeseci", hr: "listopad", de: "Oktober" },
  { id: "v91", cat: "Dani i mjeseci", hr: "studeni", de: "November" },
  { id: "v92", cat: "Dani i mjeseci", hr: "prosinac", de: "Dezember" },

  { id: "v93", cat: "Vrijeme", hr: "danas", de: "heute" },
  { id: "v94", cat: "Vrijeme", hr: "sutra", de: "morgen" },
  { id: "v95", cat: "Vrijeme", hr: "jučer", de: "gestern" },
  { id: "v96", cat: "Vrijeme", hr: "sada", de: "jetzt" },
  { id: "v97", cat: "Vrijeme", hr: "ujutro", de: "morgens" },
  { id: "v98", cat: "Vrijeme", hr: "popodne", de: "nachmittags" },
  { id: "v99", cat: "Vrijeme", hr: "navečer", de: "abends" },
  { id: "v100", cat: "Vrijeme", hr: "noć", de: "Nacht" },
  { id: "v101", cat: "Vrijeme", hr: "sat", de: "Stunde / Uhr" },
  { id: "v102", cat: "Vrijeme", hr: "minuta", de: "Minute" },
  { id: "v103", cat: "Vrijeme", hr: "dan", de: "Tag" },
  { id: "v104", cat: "Vrijeme", hr: "mjesec", de: "Monat" },
  { id: "v105", cat: "Vrijeme", hr: "godina", de: "Jahr" },
  { id: "v106", cat: "Vrijeme", hr: "u koliko sati?", de: "um wie viel Uhr?" },
  { id: "v107", cat: "Vrijeme", hr: "kasno", de: "spät" },
  { id: "v108", cat: "Vrijeme", hr: "rano", de: "früh" },
  { id: "v109", cat: "Vrijeme", hr: "uvijek", de: "immer" },
  { id: "v110", cat: "Vrijeme", hr: "nikad", de: "nie" },
  { id: "v111", cat: "Vrijeme", hr: "ponekad", de: "manchmal" },
  { id: "v112", cat: "Vrijeme", hr: "često", de: "oft" },

  { id: "v113", cat: "Pitanja", hr: "tko", de: "wer" },
  { id: "v114", cat: "Pitanja", hr: "što", de: "was" },
  { id: "v115", cat: "Pitanja", hr: "gdje", de: "wo" },
  { id: "v116", cat: "Pitanja", hr: "kamo", de: "wohin" },
  { id: "v117", cat: "Pitanja", hr: "odakle", de: "woher" },
  { id: "v118", cat: "Pitanja", hr: "kada", de: "wann" },
  { id: "v119", cat: "Pitanja", hr: "zašto", de: "warum" },
  { id: "v120", cat: "Pitanja", hr: "kako", de: "wie" },
  { id: "v121", cat: "Pitanja", hr: "koliko", de: "wie viel" },
  { id: "v122", cat: "Pitanja", hr: "koji", de: "welcher" },
  { id: "v123", cat: "Pitanja", hr: "čiji", de: "wessen" },

  { id: "v124", cat: "Zamjenice", hr: "ja", de: "ich" },
  { id: "v125", cat: "Zamjenice", hr: "ti", de: "du" },
  { id: "v126", cat: "Zamjenice", hr: "on", de: "er" },
  { id: "v127", cat: "Zamjenice", hr: "ona", de: "sie" },
  { id: "v128", cat: "Zamjenice", hr: "ono", de: "es" },
  { id: "v129", cat: "Zamjenice", hr: "mi", de: "wir" },
  { id: "v130", cat: "Zamjenice", hr: "vi", de: "ihr / Sie" },
  { id: "v131", cat: "Zamjenice", hr: "oni", de: "sie (Pl. m)" },
  { id: "v132", cat: "Zamjenice", hr: "one", de: "sie (Pl. f)" },
  { id: "v133", cat: "Zamjenice", hr: "moj", de: "mein" },
  { id: "v134", cat: "Zamjenice", hr: "tvoj", de: "dein" },
  { id: "v135", cat: "Zamjenice", hr: "njegov", de: "sein" },
  { id: "v136", cat: "Zamjenice", hr: "njezin", de: "ihr" },
  { id: "v137", cat: "Zamjenice", hr: "naš", de: "unser" },
  { id: "v138", cat: "Zamjenice", hr: "vaš", de: "euer / Ihr" },
  { id: "v139", cat: "Zamjenice", hr: "njihov", de: "ihr (Pl.)" },
  { id: "v140", cat: "Zamjenice", hr: "ovo", de: "das (hier)" },
  { id: "v141", cat: "Zamjenice", hr: "to", de: "das" },
  { id: "v142", cat: "Zamjenice", hr: "ovaj", de: "dieser" },

  { id: "v143", cat: "Hrana i piće", hr: "voda", de: "Wasser" },
  { id: "v144", cat: "Hrana i piće", hr: "kruh", de: "Brot" },
  { id: "v145", cat: "Hrana i piće", hr: "mlijeko", de: "Milch" },
  { id: "v146", cat: "Hrana i piće", hr: "kava", de: "Kaffee" },
  { id: "v147", cat: "Hrana i piće", hr: "čaj", de: "Tee" },
  { id: "v148", cat: "Hrana i piće", hr: "pivo", de: "Bier" },
  { id: "v149", cat: "Hrana i piće", hr: "vino", de: "Wein" },
  { id: "v150", cat: "Hrana i piće", hr: "sok", de: "Saft" },
  { id: "v151", cat: "Hrana i piće", hr: "meso", de: "Fleisch" },
  { id: "v152", cat: "Hrana i piće", hr: "riba", de: "Fisch" },
  { id: "v153", cat: "Hrana i piće", hr: "sir", de: "Käse" },
  { id: "v154", cat: "Hrana i piće", hr: "jaje", de: "Ei" },
  { id: "v155", cat: "Hrana i piće", hr: "povrće", de: "Gemüse" },
  { id: "v156", cat: "Hrana i piće", hr: "voće", de: "Obst" },
  { id: "v157", cat: "Hrana i piće", hr: "jabuka", de: "Apfel" },
  { id: "v158", cat: "Hrana i piće", hr: "juha", de: "Suppe" },
  { id: "v159", cat: "Hrana i piće", hr: "salata", de: "Salat" },
  { id: "v160", cat: "Hrana i piće", hr: "kolač", de: "Kuchen" },
  { id: "v161", cat: "Hrana i piće", hr: "sol", de: "Salz" },
  { id: "v162", cat: "Hrana i piće", hr: "šećer", de: "Zucker" },
  { id: "v163", cat: "Hrana i piće", hr: "doručak", de: "Frühstück" },
  { id: "v164", cat: "Hrana i piće", hr: "ručak", de: "Mittagessen" },
  { id: "v165", cat: "Hrana i piće", hr: "večera", de: "Abendessen" },
  { id: "v166", cat: "Hrana i piće", hr: "restoran", de: "Restaurant" },
  { id: "v167", cat: "Hrana i piće", hr: "jelovnik", de: "Speisekarte" },
  { id: "v168", cat: "Hrana i piće", hr: "gladan sam", de: "ich habe Hunger" },
  { id: "v169", cat: "Hrana i piće", hr: "žedan sam", de: "ich habe Durst" },
  { id: "v170", cat: "Hrana i piće", hr: "dobar tek", de: "guten Appetit" },
  { id: "v171", cat: "Hrana i piće", hr: "ukusno", de: "lecker" },

  { id: "v172", cat: "Kupovina", hr: "trgovina", de: "Geschäft" },
  { id: "v173", cat: "Kupovina", hr: "dućan", de: "Laden" },
  { id: "v174", cat: "Kupovina", hr: "tržnica", de: "Markt" },
  { id: "v175", cat: "Kupovina", hr: "novac", de: "Geld" },
  { id: "v176", cat: "Kupovina", hr: "cijena", de: "Preis" },
  { id: "v177", cat: "Kupovina", hr: "koliko košta?", de: "wie viel kostet?" },
  { id: "v178", cat: "Kupovina", hr: "račun", de: "Rechnung" },
  { id: "v179", cat: "Kupovina", hr: "kartica", de: "Karte" },
  { id: "v180", cat: "Kupovina", hr: "gotovina", de: "Bargeld" },
  { id: "v181", cat: "Kupovina", hr: "jeftino", de: "billig" },
  { id: "v182", cat: "Kupovina", hr: "skupo", de: "teuer" },
  { id: "v183", cat: "Kupovina", hr: "popust", de: "Rabatt" },
  { id: "v184", cat: "Kupovina", hr: "vrećica", de: "Tüte" },
  { id: "v185", cat: "Kupovina", hr: "kupiti", de: "kaufen" },
  { id: "v186", cat: "Kupovina", hr: "platiti", de: "bezahlen" },
  { id: "v187", cat: "Kupovina", hr: "trebam", de: "ich brauche" },
  { id: "v188", cat: "Kupovina", hr: "želim", de: "ich möchte" },
  { id: "v189", cat: "Kupovina", hr: "imate li ...?", de: "haben Sie ...?" },

  { id: "v190", cat: "Smjer i prijevoz", hr: "lijevo", de: "links" },
  { id: "v191", cat: "Smjer i prijevoz", hr: "desno", de: "rechts" },
  { id: "v192", cat: "Smjer i prijevoz", hr: "ravno", de: "geradeaus" },
  { id: "v193", cat: "Smjer i prijevoz", hr: "blizu", de: "nah" },
  { id: "v194", cat: "Smjer i prijevoz", hr: "daleko", de: "weit" },
  { id: "v195", cat: "Smjer i prijevoz", hr: "ovdje", de: "hier" },
  { id: "v196", cat: "Smjer i prijevoz", hr: "ondje", de: "dort" },
  { id: "v197", cat: "Smjer i prijevoz", hr: "gore", de: "oben" },
  { id: "v198", cat: "Smjer i prijevoz", hr: "dolje", de: "unten" },
  { id: "v199", cat: "Smjer i prijevoz", hr: "autobus", de: "Bus" },
  { id: "v200", cat: "Smjer i prijevoz", hr: "vlak", de: "Zug" },
  { id: "v201", cat: "Smjer i prijevoz", hr: "tramvaj", de: "Straßenbahn" },
  { id: "v202", cat: "Smjer i prijevoz", hr: "auto", de: "Auto" },
  { id: "v203", cat: "Smjer i prijevoz", hr: "taksi", de: "Taxi" },
  { id: "v204", cat: "Smjer i prijevoz", hr: "bicikl", de: "Fahrrad" },
  { id: "v205", cat: "Smjer i prijevoz", hr: "zračna luka", de: "Flughafen" },
  { id: "v206", cat: "Smjer i prijevoz", hr: "kolodvor", de: "Bahnhof" },
  { id: "v207", cat: "Smjer i prijevoz", hr: "ulica", de: "Straße" },
  { id: "v208", cat: "Smjer i prijevoz", hr: "trg", de: "Platz" },
  { id: "v209", cat: "Smjer i prijevoz", hr: "karta", de: "Fahrkarte" },
  { id: "v210", cat: "Smjer i prijevoz", hr: "gdje je ...?", de: "wo ist ...?" },

  { id: "v211", cat: "Stanovanje", hr: "kuća", de: "Haus" },
  { id: "v212", cat: "Stanovanje", hr: "stan", de: "Wohnung" },
  { id: "v213", cat: "Stanovanje", hr: "soba", de: "Zimmer" },
  { id: "v214", cat: "Stanovanje", hr: "kuhinja", de: "Küche" },
  { id: "v215", cat: "Stanovanje", hr: "kupaonica", de: "Badezimmer" },
  { id: "v216", cat: "Stanovanje", hr: "spavaća soba", de: "Schlafzimmer" },
  { id: "v217", cat: "Stanovanje", hr: "dnevni boravak", de: "Wohnzimmer" },
  { id: "v218", cat: "Stanovanje", hr: "vrata", de: "Tür" },
  { id: "v219", cat: "Stanovanje", hr: "prozor", de: "Fenster" },
  { id: "v220", cat: "Stanovanje", hr: "stol", de: "Tisch" },
  { id: "v221", cat: "Stanovanje", hr: "stolica", de: "Stuhl" },
  { id: "v222", cat: "Stanovanje", hr: "krevet", de: "Bett" },
  { id: "v223", cat: "Stanovanje", hr: "ključ", de: "Schlüssel" },
  { id: "v224", cat: "Stanovanje", hr: "najam", de: "Miete" },
  { id: "v225", cat: "Stanovanje", hr: "grad", de: "Stadt" },
  { id: "v226", cat: "Stanovanje", hr: "selo", de: "Dorf" },

  { id: "v227", cat: "Pridjevi", hr: "velik", de: "groß", hint: "(m)" },
  { id: "v228", cat: "Pridjevi", hr: "malen", de: "klein", hint: "(m)" },
  { id: "v229", cat: "Pridjevi", hr: "dobar", de: "gut", hint: "(m)" },
  { id: "v230", cat: "Pridjevi", hr: "loš", de: "schlecht", hint: "(m)" },
  { id: "v231", cat: "Pridjevi", hr: "nov", de: "neu", hint: "(m)" },
  { id: "v232", cat: "Pridjevi", hr: "star", de: "alt", hint: "(m)" },
  { id: "v233", cat: "Pridjevi", hr: "lijep", de: "schön", hint: "(m)" },
  { id: "v234", cat: "Pridjevi", hr: "ružan", de: "hässlich", hint: "(m)" },
  { id: "v235", cat: "Pridjevi", hr: "brz", de: "schnell", hint: "(m)" },
  { id: "v236", cat: "Pridjevi", hr: "spor", de: "langsam", hint: "(m)" },
  { id: "v237", cat: "Pridjevi", hr: "vruć", de: "heiß", hint: "(m)" },
  { id: "v238", cat: "Pridjevi", hr: "hladan", de: "kalt", hint: "(m)" },
  { id: "v239", cat: "Pridjevi", hr: "topao", de: "warm", hint: "(m)" },
  { id: "v240", cat: "Pridjevi", hr: "umoran", de: "müde", hint: "(m)" },
  { id: "v241", cat: "Pridjevi", hr: "gladan", de: "hungrig", hint: "(m)" },
  { id: "v242", cat: "Pridjevi", hr: "žedan", de: "durstig", hint: "(m)" },
  { id: "v243", cat: "Pridjevi", hr: "sretan", de: "glücklich", hint: "(m)" },
  { id: "v244", cat: "Pridjevi", hr: "tužan", de: "traurig", hint: "(m)" },
  { id: "v245", cat: "Pridjevi", hr: "bolestan", de: "krank", hint: "(m)" },
  { id: "v246", cat: "Pridjevi", hr: "slobodan", de: "frei", hint: "(m)" },
  { id: "v247", cat: "Pridjevi", hr: "težak", de: "schwer", hint: "(m)" },
  { id: "v248", cat: "Pridjevi", hr: "lak", de: "leicht", hint: "(m)" },
  { id: "v249", cat: "Pridjevi", hr: "dug", de: "lang", hint: "(m)" },
  { id: "v250", cat: "Pridjevi", hr: "kratak", de: "kurz", hint: "(m)" },

  { id: "v251", cat: "Glagoli", hr: "biti", de: "sein" },
  { id: "v252", cat: "Glagoli", hr: "imati", de: "haben" },
  { id: "v253", cat: "Glagoli", hr: "raditi", de: "arbeiten" },
  { id: "v254", cat: "Glagoli", hr: "govoriti", de: "sprechen" },
  { id: "v255", cat: "Glagoli", hr: "učiti", de: "lernen" },
  { id: "v256", cat: "Glagoli", hr: "živjeti", de: "leben" },
  { id: "v257", cat: "Glagoli", hr: "jesti", de: "essen" },
  { id: "v258", cat: "Glagoli", hr: "piti", de: "trinken" },
  { id: "v259", cat: "Glagoli", hr: "ići", de: "gehen" },
  { id: "v260", cat: "Glagoli", hr: "doći", de: "kommen" },
  { id: "v261", cat: "Glagoli", hr: "htjeti", de: "wollen" },
  { id: "v262", cat: "Glagoli", hr: "moći", de: "können" },
  { id: "v263", cat: "Glagoli", hr: "morati", de: "müssen" },
  { id: "v264", cat: "Glagoli", hr: "znati", de: "wissen" },
  { id: "v265", cat: "Glagoli", hr: "razumjeti", de: "verstehen" },
  { id: "v266", cat: "Glagoli", hr: "čitati", de: "lesen" },
  { id: "v267", cat: "Glagoli", hr: "pisati", de: "schreiben" },
  { id: "v268", cat: "Glagoli", hr: "gledati", de: "schauen" },
  { id: "v269", cat: "Glagoli", hr: "slušati", de: "hören" },
  { id: "v270", cat: "Glagoli", hr: "vidjeti", de: "sehen" },
  { id: "v271", cat: "Glagoli", hr: "trebati", de: "brauchen" },
  { id: "v272", cat: "Glagoli", hr: "voljeti", de: "lieben / mögen" },
  { id: "v273", cat: "Glagoli", hr: "spavati", de: "schlafen" },
  { id: "v274", cat: "Glagoli", hr: "kuhati", de: "kochen" },
  { id: "v275", cat: "Glagoli", hr: "putovati", de: "reisen" },
  { id: "v276", cat: "Glagoli", hr: "čekati", de: "warten" },
  { id: "v277", cat: "Glagoli", hr: "platiti", de: "bezahlen" },
  { id: "v278", cat: "Glagoli", hr: "reći", de: "sagen" },

  { id: "v279", cat: "Fraze", hr: "Što radiš?", de: "Was machst du?" },
  { id: "v280", cat: "Fraze", hr: "Nemam vremena.", de: "Ich habe keine Zeit." },
  { id: "v281", cat: "Fraze", hr: "Imaš li vremena?", de: "Hast du Zeit?" },
  { id: "v282", cat: "Fraze", hr: "Gdje je toalet?", de: "Wo ist die Toilette?" },
  { id: "v283", cat: "Fraze", hr: "Govorite li engleski?", de: "Sprechen Sie Englisch?" },
  { id: "v284", cat: "Fraze", hr: "Ne znam.", de: "Ich weiß nicht." },
  { id: "v285", cat: "Fraze", hr: "U redu.", de: "In Ordnung." },
  { id: "v286", cat: "Fraze", hr: "Nema problema.", de: "Kein Problem." },
  { id: "v287", cat: "Fraze", hr: "Volim te.", de: "Ich liebe dich." },
  { id: "v288", cat: "Fraze", hr: "Kako se to zove?", de: "Wie heißt das?" },
  { id: "v289", cat: "Fraze", hr: "Možeš li mi pomoći?", de: "Kannst du mir helfen?" },
  { id: "v290", cat: "Fraze", hr: "Sviđa mi se.", de: "Es gefällt mir." },
  { id: "v291", cat: "Fraze", hr: "Ne osjećam se dobro.", de: "Ich fühle mich nicht gut." },
  { id: "v292", cat: "Fraze", hr: "Vidimo se sutra.", de: "Bis morgen." },

  { id: "c0_0", cat: "Konjugacija", verb: "biti", pron: "ja", answer: "sam", isConj: true },
  { id: "c0_1", cat: "Konjugacija", verb: "biti", pron: "ti", answer: "si", isConj: true },
  { id: "c0_2", cat: "Konjugacija", verb: "biti", pron: "on/ona/ono", answer: "je", isConj: true },
  { id: "c0_3", cat: "Konjugacija", verb: "biti", pron: "mi", answer: "smo", isConj: true },
  { id: "c0_4", cat: "Konjugacija", verb: "biti", pron: "vi", answer: "ste", isConj: true },
  { id: "c0_5", cat: "Konjugacija", verb: "biti", pron: "oni/one", answer: "su", isConj: true },

  { id: "c1_0", cat: "Konjugacija", verb: "imati", pron: "ja", answer: "imam", isConj: true },
  { id: "c1_1", cat: "Konjugacija", verb: "imati", pron: "ti", answer: "imaš", isConj: true },
  { id: "c1_2", cat: "Konjugacija", verb: "imati", pron: "on/ona/ono", answer: "ima", isConj: true },
  { id: "c1_3", cat: "Konjugacija", verb: "imati", pron: "mi", answer: "imamo", isConj: true },
  { id: "c1_4", cat: "Konjugacija", verb: "imati", pron: "vi", answer: "imate", isConj: true },
  { id: "c1_5", cat: "Konjugacija", verb: "imati", pron: "oni/one", answer: "imaju", isConj: true },

  { id: "c2_0", cat: "Konjugacija", verb: "raditi", pron: "ja", answer: "radim", isConj: true },
  { id: "c2_1", cat: "Konjugacija", verb: "raditi", pron: "ti", answer: "radiš", isConj: true },
  { id: "c2_2", cat: "Konjugacija", verb: "raditi", pron: "on/ona/ono", answer: "radi", isConj: true },
  { id: "c2_3", cat: "Konjugacija", verb: "raditi", pron: "mi", answer: "radimo", isConj: true },
  { id: "c2_4", cat: "Konjugacija", verb: "raditi", pron: "vi", answer: "radite", isConj: true },
  { id: "c2_5", cat: "Konjugacija", verb: "raditi", pron: "oni/one", answer: "rade", isConj: true },

  { id: "c3_0", cat: "Konjugacija", verb: "govoriti", pron: "ja", answer: "govorim", isConj: true },
  { id: "c3_1", cat: "Konjugacija", verb: "govoriti", pron: "ti", answer: "govoriš", isConj: true },
  { id: "c3_2", cat: "Konjugacija", verb: "govoriti", pron: "on/ona/ono", answer: "govori", isConj: true },
  { id: "c3_3", cat: "Konjugacija", verb: "govoriti", pron: "mi", answer: "govorimo", isConj: true },
  { id: "c3_4", cat: "Konjugacija", verb: "govoriti", pron: "vi", answer: "govorite", isConj: true },
  { id: "c3_5", cat: "Konjugacija", verb: "govoriti", pron: "oni/one", answer: "govore", isConj: true },

  { id: "c4_0", cat: "Konjugacija", verb: "živjeti", pron: "ja", answer: "živim", isConj: true },
  { id: "c4_1", cat: "Konjugacija", verb: "živjeti", pron: "ti", answer: "živiš", isConj: true },
  { id: "c4_2", cat: "Konjugacija", verb: "živjeti", pron: "on/ona/ono", answer: "živi", isConj: true },
  { id: "c4_3", cat: "Konjugacija", verb: "živjeti", pron: "mi", answer: "živimo", isConj: true },
  { id: "c4_4", cat: "Konjugacija", verb: "živjeti", pron: "vi", answer: "živite", isConj: true },
  { id: "c4_5", cat: "Konjugacija", verb: "živjeti", pron: "oni/one", answer: "žive", isConj: true },

  { id: "c5_0", cat: "Konjugacija", verb: "jesti", pron: "ja", answer: "jedem", isConj: true },
  { id: "c5_1", cat: "Konjugacija", verb: "jesti", pron: "ti", answer: "jedeš", isConj: true },
  { id: "c5_2", cat: "Konjugacija", verb: "jesti", pron: "on/ona/ono", answer: "jede", isConj: true },
  { id: "c5_3", cat: "Konjugacija", verb: "jesti", pron: "mi", answer: "jedemo", isConj: true },
  { id: "c5_4", cat: "Konjugacija", verb: "jesti", pron: "vi", answer: "jedete", isConj: true },
  { id: "c5_5", cat: "Konjugacija", verb: "jesti", pron: "oni/one", answer: "jedu", isConj: true },

  { id: "c6_0", cat: "Konjugacija", verb: "piti", pron: "ja", answer: "pijem", isConj: true },
  { id: "c6_1", cat: "Konjugacija", verb: "piti", pron: "ti", answer: "piješ", isConj: true },
  { id: "c6_2", cat: "Konjugacija", verb: "piti", pron: "on/ona/ono", answer: "pije", isConj: true },
  { id: "c6_3", cat: "Konjugacija", verb: "piti", pron: "mi", answer: "pijemo", isConj: true },
  { id: "c6_4", cat: "Konjugacija", verb: "piti", pron: "vi", answer: "pijete", isConj: true },
  { id: "c6_5", cat: "Konjugacija", verb: "piti", pron: "oni/one", answer: "piju", isConj: true },

  { id: "c7_0", cat: "Konjugacija", verb: "htjeti", pron: "ja", answer: "hoću", isConj: true },
  { id: "c7_1", cat: "Konjugacija", verb: "htjeti", pron: "ti", answer: "hoćeš", isConj: true },
  { id: "c7_2", cat: "Konjugacija", verb: "htjeti", pron: "on/ona/ono", answer: "hoće", isConj: true },
  { id: "c7_3", cat: "Konjugacija", verb: "htjeti", pron: "mi", answer: "hoćemo", isConj: true },
  { id: "c7_4", cat: "Konjugacija", verb: "htjeti", pron: "vi", answer: "hoćete", isConj: true },
  { id: "c7_5", cat: "Konjugacija", verb: "htjeti", pron: "oni/one", answer: "hoće", isConj: true },

  { id: "c8_0", cat: "Konjugacija", verb: "moći", pron: "ja", answer: "mogu", isConj: true },
  { id: "c8_1", cat: "Konjugacija", verb: "moći", pron: "ti", answer: "možeš", isConj: true },
  { id: "c8_2", cat: "Konjugacija", verb: "moći", pron: "on/ona/ono", answer: "može", isConj: true },
  { id: "c8_3", cat: "Konjugacija", verb: "moći", pron: "mi", answer: "možemo", isConj: true },
  { id: "c8_4", cat: "Konjugacija", verb: "moći", pron: "vi", answer: "možete", isConj: true },
  { id: "c8_5", cat: "Konjugacija", verb: "moći", pron: "oni/one", answer: "mogu", isConj: true },

  { id: "s0", cat: "Rečenice", hr: "Ja sam iz Njemačke.", de: "Ich komme aus Deutschland.", tokens: ["Ja", "sam", "iz", "Njemačke."], isSentence: true },
  { id: "s1", cat: "Rečenice", hr: "Kako se zoveš?", de: "Wie heißt du?", tokens: ["Kako", "se", "zoveš?"], isSentence: true },
  { id: "s2", cat: "Rečenice", hr: "Imam dvadeset godina.", de: "Ich bin zwanzig Jahre alt.", tokens: ["Imam", "dvadeset", "godina."], isSentence: true },
  { id: "s3", cat: "Rečenice", hr: "Govorim malo hrvatski.", de: "Ich spreche ein bisschen Kroatisch.", tokens: ["Govorim", "malo", "hrvatski."], isSentence: true },
  { id: "s4", cat: "Rečenice", hr: "Gdje je kolodvor?", de: "Wo ist der Bahnhof?", tokens: ["Gdje", "je", "kolodvor?"], isSentence: true },
  { id: "s5", cat: "Rečenice", hr: "Koliko košta kava?", de: "Wie viel kostet der Kaffee?", tokens: ["Koliko", "košta", "kava?"], isSentence: true },
  { id: "s6", cat: "Rečenice", hr: "Volim hrvatsko vino.", de: "Ich liebe kroatischen Wein.", tokens: ["Volim", "hrvatsko", "vino."], isSentence: true },
  { id: "s7", cat: "Rečenice", hr: "Ne razumijem te.", de: "Ich verstehe dich nicht.", tokens: ["Ne", "razumijem", "te."], isSentence: true },
  { id: "s8", cat: "Rečenice", hr: "Idem u trgovinu.", de: "Ich gehe in den Laden.", tokens: ["Idem", "u", "trgovinu."], isSentence: true },
  { id: "s9", cat: "Rečenice", hr: "Sutra idemo na more.", de: "Morgen fahren wir ans Meer.", tokens: ["Sutra", "idemo", "na", "more."], isSentence: true },
  { id: "s10", cat: "Rečenice", hr: "Imaš li vremena?", de: "Hast du Zeit?", tokens: ["Imaš", "li", "vremena?"], isSentence: true },
  { id: "s11", cat: "Rečenice", hr: "Možeš li mi pomoći?", de: "Kannst du mir helfen?", tokens: ["Možeš", "li", "mi", "pomoći?"], isSentence: true },
  { id: "s12", cat: "Rečenice", hr: "Gdje živiš?", de: "Wo wohnst du?", tokens: ["Gdje", "živiš?"], isSentence: true },
  { id: "s13", cat: "Rečenice", hr: "Živim u Berlinu.", de: "Ich wohne in Berlin.", tokens: ["Živim", "u", "Berlinu."], isSentence: true },
  { id: "s14", cat: "Rečenice", hr: "Imam jednu sestru.", de: "Ich habe eine Schwester.", tokens: ["Imam", "jednu", "sestru."], isSentence: true },
  { id: "s15", cat: "Rečenice", hr: "On je moj prijatelj.", de: "Er ist mein Freund.", tokens: ["On", "je", "moj", "prijatelj."], isSentence: true },
  { id: "s16", cat: "Rečenice", hr: "Što radiš sutra?", de: "Was machst du morgen?", tokens: ["Što", "radiš", "sutra?"], isSentence: true },
  { id: "s17", cat: "Rečenice", hr: "Radim u uredu.", de: "Ich arbeite im Büro.", tokens: ["Radim", "u", "uredu."], isSentence: true },
  { id: "s18", cat: "Rečenice", hr: "Učim hrvatski jezik.", de: "Ich lerne Kroatisch.", tokens: ["Učim", "hrvatski", "jezik."], isSentence: true },
  { id: "s19", cat: "Rečenice", hr: "Pijem kavu svako jutro.", de: "Ich trinke jeden Morgen Kaffee.", tokens: ["Pijem", "kavu", "svako", "jutro."], isSentence: true },
  { id: "s20", cat: "Rečenice", hr: "Jedem kruh i sir.", de: "Ich esse Brot und Käse.", tokens: ["Jedem", "kruh", "i", "sir."], isSentence: true },
  { id: "s21", cat: "Rečenice", hr: "Hoću jednu pivu.", de: "Ich möchte ein Bier.", tokens: ["Hoću", "jednu", "pivu."], isSentence: true },
  { id: "s22", cat: "Rečenice", hr: "Molim te, jedan sok.", de: "Bitte einen Saft.", tokens: ["Molim", "te,", "jedan", "sok."], isSentence: true },
  { id: "s23", cat: "Rečenice", hr: "Račun, molim.", de: "Die Rechnung, bitte.", tokens: ["Račun,", "molim."], isSentence: true },
  { id: "s24", cat: "Rečenice", hr: "Plaćam karticom.", de: "Ich zahle mit Karte.", tokens: ["Plaćam", "karticom."], isSentence: true },
  { id: "s25", cat: "Rečenice", hr: "To je previše skupo.", de: "Das ist zu teuer.", tokens: ["To", "je", "previše", "skupo."], isSentence: true },
  { id: "s26", cat: "Rečenice", hr: "Trebam novu kartu.", de: "Ich brauche eine neue Fahrkarte.", tokens: ["Trebam", "novu", "kartu."], isSentence: true },
  { id: "s27", cat: "Rečenice", hr: "Autobus dolazi u devet.", de: "Der Bus kommt um neun.", tokens: ["Autobus", "dolazi", "u", "devet."], isSentence: true },
  { id: "s28", cat: "Rečenice", hr: "Vlak ide u Zagreb.", de: "Der Zug fährt nach Zagreb.", tokens: ["Vlak", "ide", "u", "Zagreb."], isSentence: true },
  { id: "s29", cat: "Rečenice", hr: "Idi ravno pa lijevo.", de: "Geh geradeaus und dann links.", tokens: ["Idi", "ravno", "pa", "lijevo."], isSentence: true },
  { id: "s30", cat: "Rečenice", hr: "Danas je lijep dan.", de: "Heute ist ein schöner Tag.", tokens: ["Danas", "je", "lijep", "dan."], isSentence: true },
  { id: "s31", cat: "Rečenice", hr: "Sutra je subota.", de: "Morgen ist Samstag.", tokens: ["Sutra", "je", "subota."], isSentence: true },
  { id: "s32", cat: "Rečenice", hr: "U koliko sati počinje?", de: "Um wie viel Uhr beginnt es?", tokens: ["U", "koliko", "sati", "počinje?"], isSentence: true },
  { id: "s33", cat: "Rečenice", hr: "Imam dva brata.", de: "Ich habe zwei Brüder.", tokens: ["Imam", "dva", "brata."], isSentence: true },
  { id: "s34", cat: "Rečenice", hr: "Volim te jako.", de: "Ich liebe dich sehr.", tokens: ["Volim", "te", "jako."], isSentence: true },
  { id: "s35", cat: "Rečenice", hr: "Vidimo se večeras.", de: "Bis heute Abend.", tokens: ["Vidimo", "se", "večeras."], isSentence: true },
  { id: "s36", cat: "Rečenice", hr: "Idem spavati.", de: "Ich gehe schlafen.", tokens: ["Idem", "spavati."], isSentence: true },
  { id: "s37", cat: "Rečenice", hr: "Sviđa mi se ovaj grad.", de: "Diese Stadt gefällt mir.", tokens: ["Sviđa", "mi", "se", "ovaj", "grad."], isSentence: true },
  { id: "s38", cat: "Rečenice", hr: "Ne osjećam se dobro.", de: "Ich fühle mich nicht gut.", tokens: ["Ne", "osjećam", "se", "dobro."], isSentence: true },
  { id: "s39", cat: "Rečenice", hr: "Možeš li ponoviti, molim?", de: "Kannst du wiederholen, bitte?", tokens: ["Možeš", "li", "ponoviti,", "molim?"], isSentence: true },
];

export const CARDS: Card[] = [...A1_CARDS, ...EXTRA_CARDS];
